import { createTheme, Theme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    tertiary: Palette["primary"];
  }
  interface PaletteOptions {
    tertiary?: PaletteOptions["primary"];
  }
}

export const createAppTheme = (isDark: boolean): Theme =>
  createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
    },
    palette: {
      mode: isDark ? "dark" : "light",
      primary: { main: "#4C3699" },
      secondary: { main: "#92EF8F" },
      tertiary: { main: "#36276F" },
      success: { main: "#7956F7" },
      ...(isDark && {
        background: {
          default: "#141414",
          paper: "rgba(20, 20, 20, 0.98)",
        },
      }),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: isDark
            ? {}
            : {
                background:
                  "radial-gradient(circle at top right, #7956F7 0%, transparent 60%) no-repeat, " +
                  "radial-gradient(circle at bottom left, #7956F7 0%, transparent 60%) no-repeat, " +
                  "linear-gradient(145deg, #36276F, #4C3699 50%, #36276F)",
                "@media (max-width: 767px)": {
                  background: "#F5F5F5 !important",
                },
              },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "filled",
        },
        styleOverrides: {
          root: {
            "& label.Mui-focused": { color: "#4C3699" },
            "& .MuiFilledInput-root": {
              borderRadius: "0.375rem",
              backgroundColor: isDark ? "rgba(255,255,255,0.08)" : "#4140421A",
              "&:hover": {
                backgroundColor: isDark
                  ? "rgba(255,255,255,0.12)"
                  : "#4140421A",
              },
              "&.Mui-focused": {
                backgroundColor: isDark
                  ? "rgba(255,255,255,0.12)"
                  : "#4140421A",
              },
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "1.125rem",
            fontWeight: "bold",
            padding: "0.625rem",
          },
        },
      },
    },
  });

// Default light theme — used in tests and as a fallback
const theme = createAppTheme(false);
export default theme;
